import * as organizationConstants from '../constants/organizations';
import * as bucketConstants from '../constants/buckets';

export function usersByOrg(state = {}, action) {
    switch (action.type) {
        case organizationConstants.FETCH_ORGANIZATION_MEMBERS_SUCCESS: {
            const { members, organizationId } = action.payload;
            return {
                ...state,
                [organizationId]: members.map(member => ({
                    userId: member.id,
                    isAdmin: member.isAdmin,
                })),
            };
        }
        case organizationConstants.ADD_ORGANIZATION_MEMBERS_SUCCESS: {
            const { members, organizationId } = action.payload;
            const newMemberships = members.map(member => ({
                userId: member.id,
                isAdmin: member.isAdmin,
            }));
            return {
                ...state,
                [organizationId]: [...newMemberships, ...state[organizationId]],
            };
        }
        case organizationConstants.CHANGE_USERS_ROLE_SUCCESS: {
            const { members, organizationId } = action.payload;
            const memberships = [...state[organizationId]];
            memberships
                .filter(
                    membership =>
                        members.findIndex(m => m.id === membership.userId) !==
                        -1,
                )
                .forEach(membership => {
                    membership.isAdmin = members.find(
                        m => m.id === membership.userId,
                    ).isAdmin;
                });
            return {
                ...state,
                [organizationId]: memberships,
            };
        }
        case organizationConstants.REMOVE_USERS_SUCCESS: {
            const { membersIds, organizationId } = action.payload;
            const memberships = [...state[organizationId]].filter(
                memberships => membersIds.indexOf(memberships.userId) === -1,
            );
            return {
                ...state,
                [organizationId]: memberships,
            };
        }
        default:
            return state;
    }
}

export function usersByBuckets(state = {}, action) {
    switch (action.type) {
        case bucketConstants.FETCH_BUCKET_MEMBERS_SUCCESS: {
            const { members, bucketId } = action.payload;
            const memberships = members.map(member => ({
                userId: member.id,
                isAdmin: member.isAdmin,
            }));
            return {
                ...state,
                [bucketId]: memberships,
            };
        }
        case bucketConstants.ADD_BUCKET_MEMBERS_SUCCESS: {
            const { members, bucketId } = action.payload;
            const memberships = members.map(member => ({
                userId: member.id,
                isAdmin: member.isAdmin,
            }));
            return {
                ...state,
                [bucketId]: [...memberships, ...(state[bucketId] || [])],
            };
        }
        case bucketConstants.CHANGE_USERS_ROLE_SUCCESS: {
            const { members, bucketId } = action.payload;
            const memberships = [...state[bucketId]];
            memberships
                .filter(
                    membership =>
                        members.findIndex(m => m.id === membership.userId) !==
                        -1,
                )
                .forEach(membership => {
                    membership.isAdmin = members.find(
                        m => m.id === membership.userId,
                    ).isAdmin;
                });
            return {
                ...state,
                [bucketId]: memberships,
            };
        }
        case bucketConstants.REMOVE_USERS_SUCCESS: {
            const { membersIds, bucketId } = action.payload;
            const memberships = [...state[bucketId]].filter(
                memberships => membersIds.indexOf(memberships.userId) === -1,
            );
            return {
                ...state,
                [bucketId]: memberships,
            };
        }
        case bucketConstants.ADD_USERS_TO_BUCKETS_SUCCESS: {
            const { membershipResponses, bucketIds } = action.payload;
            let usersByOrganizationBuckets = {};
            bucketIds.forEach(bucketId => {
                usersByOrganizationBuckets[bucketId] = [
                    ...(state[bucketId] || []),
                ];
                let membersInState = usersByOrganizationBuckets[bucketId].map(
                    member => member.userId,
                );
                if (membershipResponses[bucketId]) {
                    membershipResponses[bucketId].forEach(membership => {
                        if (membersInState.indexOf(membership.userId) === -1) {
                            usersByOrganizationBuckets[bucketId].push(
                                membership,
                            );
                        }
                    });
                }
            });
            return usersByOrganizationBuckets;
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/usersReducer.js